export const avaAnchor = {
	id: ``,
	icon: 'sparkles',
	text: 'App.AIChat.Name',
	tooltip: 'App.AIChat.Title',
	aStyle: {
		transform: 'rotate(-90deg) translate(2px,0px)',
		justifyContent: 'space-evenly',
		transformOrigin: '50px 0px 0px',
		fontSize: '20px',
		width: '100px',
		// override because rotated
		borderRadius: '0',
		borderTopLeftRadius: '0.3rem',
		borderTopRightRadius: '0.3rem',
	},
}

export function objectToStyleAttribute(styleObj: Record<string, string>) {
	return JSON.stringify(styleObj || {}, null, '\t')
		.replace(/"/g, '')
		.replace(/,\n/g, ';')
		.replace(/\}/g, ';}')
		.replace(/^{/, '')
		.replace(/}$/, '')
}

export function linkButton(text: string, href: string) {
	return `<div style="padding: 10px 0;">${link(text, href)}</div>`
}

export function link(text: string, href: string, color = '#155aa7') {
	return `<span style="color: ${color}; cursor: pointer" onclick="window.navigateByUrl('${href}')" class="app-link">${text}</span>`
}

export function suggestionButton(html: string) {
	return `<button class="deep-chat-button deep-chat-suggestion-button" style="margin-top: 5px; text-align: left;">${html}</button>`
}

export function temporaryText(html: string) {
	return `<div class="deep-chat-temporary-message">${html}</div>`
}

export function systemMessage<M extends Record<string, any>>(props: M) : M {
	return {
		...props,
		role: 'system',
	}
}

export const chatExportButton = {
	position: "outside-end",
	styles: {
		button: {
			default: {
				container: {
					default: {
						'margin-bottom': '26px',
						width: '1.2em',
						height: '1.2em',
						opacity: '0.7',
						left: 'calc(-0.55em + 12px)'
					},
					hover: {"opacity": "1"},
				},
				svg: {
					content: `
						<a class="chat-export-button" data-tooltip-translate="Actions.Export">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
								<path d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width="3"></path>
							</svg>
						</a>
					`
				},
			},
		}
	}
}

export const chatTrashButton = {
	position: "outside-end",
	styles: {
		button: {
			default: {
				container: {
					default: {"margin-bottom": "6px", "width": "1em", "height": "1em", "opacity": ".7"},
					hover: {"opacity": "1"},
				},
				svg: {
					content: `
						<a class="chat-trash-button" data-tooltip-translate="Actions.Clear">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
								<path fill="currentColor" d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
							</svg>
						</a>
					`
				},
			}
		}
	}
}

export const chatCopyButton = {
	styles: {
		button: {
			default: {
				container: {
					default: {cursor: 'pointer', opacity: '.7'},
					hover: {opacity: '1'},
				},
				svg: {
					content: `
						<svg class="chat-copy-button" data-tooltip-translate="Actions.Copy" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
							<path d="M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16M5.2 16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908C16 14.4802 16 13.9201 16 12.8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.07989 16 5.2 16Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					`
				},
			}
		}
	}
}
